<div class="login-right glass-effect">
  <a mat-button [routerLink]="['/auth']">
    Retour au login</a>
  <h2>Mot de passe oublié ?</h2>
  <h3>Remplisez ce formulaire afin de réinitialiser votre mot de passe.</h3>

  <form (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" [(ngModel)]="email" name="email" placeholder="Email" required
        [disabled]="isSubmitting" />
      <mat-icon class="material-symbols-outlined" matSuffix>mail</mat-icon>
      <mat-hint>*Ce champ est obligatoire.</mat-hint>
    </mat-form-field>

    <lib-button mat-flat-button color="primary" type="submit" [disabled]="isSubmitting"
      [text]="isSubmitting ? 'Envoi...' :  'Envoyer'">
    </lib-button>
  </form>
</div>